import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Layouts = styled.div``;

export const Layout = styled.div<{ $active: boolean }>`
  display: ${({ $active }) => ($active ? 'block' : 'none')};
`;
